// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
=========================================================
* Muse Ant Design Dashboard - v1.0.0
=========================================================
* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
@media (min-width: 992px) {
  .layout-dashboard .ant-layout-footer {
    margin: 0 0 20px 20px;
  }
  .layout-dashboard .ant-layout-sider.sider-primary {
    margin: 20px 0 0 20px;
    padding: 13px 20px;
    height: calc(100vh - 20px);
  }
  .layout-dashboard .ant-layout {
    width: auto;
    flex-shrink: 1;
    margin-left: 270px;
  }
  .layout-dashboard .header-control .sidebar-toggler {
    display: none;
  }
}

@media (min-width: 768px) {
  .layout-dashboard .ant-layout-header {
    margin: 10px 20px;
  }
  .layout-dashboard .header-control {
    margin-top: 0;
  }
  .layout-dashboard .header-control .header-search {
    margin: 0 7px;
  }
  .layout-dashboard .header-control .btn-sign-in span {
    display: inline;
  }
  .profile-nav-bg {
    margin-top: -87.8px;
  }
  .card-profile-head {
    margin: -53px 24px 24px;
  }
}

@media (min-width: 992px) {
  .card-billing-info.ant-card .ant-card-body {
    display: flex;
  }
  .layout-dashboard-rtl {
    overflow: auto;
  }
  .layout-dashboard-rtl .ant-layout-sider.sider-primary {
    margin: 20px 20px 0 0;
    height: calc(100vh - 20px);
  }
  .layout-dashboard-rtl .ant-layout-sider.sider-primary {
    right: 0;
    left: auto;
  }
  .layout-dashboard-rtl .ant-layout-sider.sider-primary {
    right: 0;
    left: auto;
  }
  .layout-dashboard-rtl .ant-layout {
    margin-right: 270px;
    margin-left: 0;
  }
  .layout-dashboard-rtl .ant-layout-footer {
    margin: 0 20px 20px 0;
  }
}

@media (max-width: 768px) {
  .layout-dashboard.layout-dashboard-rtl .header-control {
    justify-content: flex-end;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/responsive.css"],"names":[],"mappings":"AAAA;;;;;;;;;;CAUC;AACD;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;IACrB,0BAA0B;EAC5B;EACA;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/*!\n=========================================================\n* Muse Ant Design Dashboard - v1.0.0\n=========================================================\n* Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard\n* Copyright 2021 Creative Tim (https://www.creative-tim.com)\n* Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)\n* Coded by Creative Tim\n=========================================================\n* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n*/\n@media (min-width: 992px) {\n  .layout-dashboard .ant-layout-footer {\n    margin: 0 0 20px 20px;\n  }\n  .layout-dashboard .ant-layout-sider.sider-primary {\n    margin: 20px 0 0 20px;\n    padding: 13px 20px;\n    height: calc(100vh - 20px);\n  }\n  .layout-dashboard .ant-layout {\n    width: auto;\n    flex-shrink: 1;\n    margin-left: 270px;\n  }\n  .layout-dashboard .header-control .sidebar-toggler {\n    display: none;\n  }\n}\n\n@media (min-width: 768px) {\n  .layout-dashboard .ant-layout-header {\n    margin: 10px 20px;\n  }\n  .layout-dashboard .header-control {\n    margin-top: 0;\n  }\n  .layout-dashboard .header-control .header-search {\n    margin: 0 7px;\n  }\n  .layout-dashboard .header-control .btn-sign-in span {\n    display: inline;\n  }\n  .profile-nav-bg {\n    margin-top: -87.8px;\n  }\n  .card-profile-head {\n    margin: -53px 24px 24px;\n  }\n}\n\n@media (min-width: 992px) {\n  .card-billing-info.ant-card .ant-card-body {\n    display: flex;\n  }\n  .layout-dashboard-rtl {\n    overflow: auto;\n  }\n  .layout-dashboard-rtl .ant-layout-sider.sider-primary {\n    margin: 20px 20px 0 0;\n    height: calc(100vh - 20px);\n  }\n  .layout-dashboard-rtl .ant-layout-sider.sider-primary {\n    right: 0;\n    left: auto;\n  }\n  .layout-dashboard-rtl .ant-layout-sider.sider-primary {\n    right: 0;\n    left: auto;\n  }\n  .layout-dashboard-rtl .ant-layout {\n    margin-right: 270px;\n    margin-left: 0;\n  }\n  .layout-dashboard-rtl .ant-layout-footer {\n    margin: 0 20px 20px 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .layout-dashboard.layout-dashboard-rtl .header-control {\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
